<template>
  <v-dialog v-model="showNewDialog" max-width="800px" persistent scrollable>
    <v-form ref="form" @submit.prevent="submit" v-model="valid">
      <v-card class="window-card px-4 py-5">
        <v-overlay :value="overlay">
          <v-card class="d-flex flex-column justify-center white px-10">
            <div class="d-flex justify-center py-5">
              <v-progress-circular indeterminate color="success"></v-progress-circular>
            </div>
            <div class="d-flex justify-center pb-5 green--text text-bold">
              {{ uploadProgress }}
            </div>
          </v-card>
        </v-overlay>

        <v-card-title>
          <span class="md-title" style="color: #67ad5b">新建资源特效模型</span>
        </v-card-title>
        <v-card-text style="padding-top: 0">

          <v-text-field v-model="form.effects_name" label="特效模型名称 *" color="#4caf50"
            :rules="[(v) => !!v || '特效模型名称不能为空']"></v-text-field>
  
          <v-select v-model="form.effects_type" :items="effectsList" item-text="name" color="#4caf50" item-value="type"
            label="类型 *" no-data-text="暂无数据" :rules="[(v) => !!v || '类型不能为空']"></v-select>
            <v-file-input
            truncate-length="15"
            color="#4caf50"
            label="特效模型预览图片上传"
            @change="f => (form.effects_review_img = fileChange(f))"

            accept="image/*"
            show-size
          ></v-file-input>

          <v-file-input truncate-length="15" color="#4caf50" label="特效模型上传"
            @change="(f) => (form.effects_file = fileChange(f))"    show-size accept=".FBX,.fbx"></v-file-input>

          <v-textarea v-model="form.effects_description" label="描述" color="#4caf50"></v-textarea>

          <v-textarea v-model="form.effects_remark" label="申请备注" color="#4caf50"></v-textarea>
         
        </v-card-text>
        <v-card-actions md-alignment="right" style="margin-right: 0">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="submit" :disabled="invalidFile">提交审核</v-btn>
          <v-btn color="success" @click="cancel">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { extend } from 'vee-validate'
import { required, required_if } from 'vee-validate/dist/rules'
import { upload, ossUpload } from '@/api/user'
import { addEffectsModel} from '@/api/model_resource'
import Dropzone from 'dropzone'

extend('required', required)
extend('required_if', required_if)

const initForm = () => ({
  effects_name:'',  //特效资源名称 
  effects_type:'',  //特效资源类型
  effects_review_img:'',//特效资源预览图
  effects_file:'', //特效资源文件
  effects_description:'',//特效描述
  effects_remark:''   //特效备注
})

export default {
  props: {
    showNewDialog: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      
      valid: false,
      uid: '',
      form: initForm(),
      // 专业分类
      majorListData: [],
      // 二级分类
      level2: [],
      // 三级分类
      level3: [],
      uploadProgress: '',
      effectsList: [
        { name: '火', type: 'fire' },
        { name: '烟雾', type: 'smoke' },

      ],
      overlay: false,
    }
  },
  watch: {
    'form.model_category'(val) {
      this.initDict(val);
    }
  },
  mounted() {
    this.initDict('device')
  },
  computed: {
    invalidFile() {
      return !(
        (
          this.form.effects_name && (this.form.effects_type ||this.form.effects_file)
        ) // CAD文件、六视图文件、视频资料必须存在
      )
    }
  },
  methods: {
    /**
     * 初始化字典
     */
    initDict(cate_type) {
      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: '1'
        },
        (res) => {
          this.majorListData = res
        }
      )

    },
    fileChange(e) {
      console.log({
        e,
        f: this.form
      })
      return e
    },
    cancel() {
      this.$emit('handleCloseDialog')
    },
    async uploadFile(fieldName, file) {
      const res = await ossUpload({ path: fieldName, file });
      return res.url;
    },
    async submit() {
      this.$refs.form.validate()

      if (this.valid) {
        const form = {
          effects_name:this.form.effects_name,
          effects_type:this.form.effects_type,
          effects_review_img:this.form.effects_review_img,
          effects_file:this.form.effects_file,
          effects_description:this.form.effects_description,
          effects_remark:this.form.effects_remark,
        }

        this.overlay = true;
        if(this.form.effects_review_img){
           this.uploadProgress = '上传特效预览图...'
           form.effects_review_img = await this.uploadFile('modelImage', this.form.effects_review_img)
        }
       if (this.form.effects_file) {
           this.uploadProgress = '上传特效模型...'
           form.effects_file = await this.uploadFile('modelFile', this.form.effects_file)
      }


      await addEffectsModel(form)
          .then(res => {
            if (res.code === '200') {
              this.$notify({
                timeout: 1500,
                message: '提交成功！',
                icon: 'add_alert',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'success',
              });
              this.$emit('handleCloseDialog', res.data);
            } else {
              this.$notify({
                timeout: 1500,
                message: '提交失败！',
                horizontalAlign: 'center',
                verticalAlign: 'bottom',
                type: 'warning',
              });
            }
            // this.form = initForm();
          })

          .finally(_ => {
            this.uploadProgress = '';
            this.overlay = false;
          });



      }
    }
  }
}
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.img {
  width: 120px;
  height: 180px;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0px;
}

::v-deep .v-sheet.v-banner .v-banner__wrapper {
  padding: 0;
}

::v-deep .v-text-field__details {
  overflow: unset;
}
</style>
